<template>
  <div>Empty template</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
